export function getAvatarLabel(first_name, last_name) {
  return Array.from(first_name)[0].toUpperCase() + Array.from(last_name)[0].toUpperCase();
}

export function getAvatarColor(email) {
  let hash = 0;
  email.split('').forEach(char => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });

  let r = 0, g = 0, b = 0;
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    if (i === 0) r = value;
    if (i === 1) g = value;
    if (i === 2) b = value;
  }

  // Lighten the color
  r = Math.floor(r + (255 - r) * 0.6);
  g = Math.floor(g + (255 - g) * 0.6);
  b = Math.floor(b + (255 - b) * 0.6);

  // Ensure text readability
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  if (brightness < 128) {
    r = Math.min(255, r + 50);
    g = Math.min(255, g + 50);
    b = Math.min(255, b + 50);
  }

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
